"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberingListsImporter = void 0;
var tslib_1 = require("tslib");
var math_1 = require("@devexpress/utils/lib/utils/math");
var rtf_old_list_level_info_collection_1 = require("../model/numbering-lists/rtf-old-list-level-info-collection");
var importer_base_1 = require("./importer-base");
var NumberingListsImporter = (function (_super) {
    tslib_1.__extends(NumberingListsImporter, _super);
    function NumberingListsImporter(data) {
        var _this = _super.call(this, data) || this;
        _this.listOverrideIndexToNumberingListIndexMap = {};
        _this.numberingListToOldListLevelInfoMap = {};
        _this.paragraphStyleListOverrideIndexMap = {};
        _this.oldListLevelInfoCollection = new rtf_old_list_level_info_collection_1.RtfOldListLevelInfoCollection();
        return _this;
    }
    NumberingListsImporter.prototype.ensureNumberingListLevelValid = function (listLevelIndex) {
        return math_1.MathUtils.restrictValue(listLevelIndex, 0, 8);
    };
    NumberingListsImporter.prototype.addNumberingListToParagraph = function (paragraph, paragraphListInfo) {
        paragraph.numberingListIndex = paragraphListInfo.numberingListIndex;
        paragraph.listLevelIndex = this.ensureNumberingListLevelValid(paragraphListInfo.listLevelIndex);
    };
    NumberingListsImporter.prototype.linkParagraphStylesWithNumberingLists = function () {
        for (var _i = 0, _a = this.documentModel.paragraphStyles; _i < _a.length; _i++) {
            var style = _a[_i];
            var info = this.paragraphStyleListOverrideIndexMap[style.styleName];
            if (!info)
                return;
            var numberingListIndex = this.listOverrideIndexToNumberingListIndexMap[info.numberingListIndex];
            if (numberingListIndex == undefined || numberingListIndex < 0 || numberingListIndex >= this.documentModel.numberingLists.length)
                return;
            style.numberingListIndex = numberingListIndex;
            style.listLevelIndex = this.ensureNumberingListLevelValid(info.listLevelIndex);
        }
    };
    NumberingListsImporter.prototype.pushState = function () {
    };
    NumberingListsImporter.prototype.popState = function () {
    };
    NumberingListsImporter.prototype.startImportSubDocument = function () {
    };
    NumberingListsImporter.prototype.finalizeSubDocument = function () {
        if (this.subDocument.isMain())
            this.linkParagraphStylesWithNumberingLists();
    };
    return NumberingListsImporter;
}(importer_base_1.RtfBaseImporter));
exports.NumberingListsImporter = NumberingListsImporter;
